import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Payment, Transaction } from 'src/app/models';
import { TokenServiceService } from 'src/app/services/token-service.service';
import { AuthService } from 'src/app/services/auth.service';
import { GENERAL_CONSTANTS } from 'src/app/core/constants/General-constants';

@Component({
  selector: 'app-bnpl',
  templateUrl: './bnpl.component.html',
  styleUrls: ['./bnpl.component.scss']
})
export class BnplComponent implements OnInit {
  @Input() info: Payment;
  @Output() BNPL = new EventEmitter();

  loading: boolean;
  transaction: Transaction;
  template: string;
  templateBnpl = GENERAL_CONSTANTS.TEMPLATES.BNPL_BANCOLOMBIA;

  constructor(
    private readonly tokenService: TokenServiceService,
    private readonly authService: AuthService
  ) { }

  ngOnInit(): void {
    this.transaction = this.tokenService.getAndDecodeToken();
    this.template = this.info.template;
    this.authService.goBacknotification$.subscribe((res: boolean) => {
      if (res) this.BNPL.emit();
    });
  }
  /**
   * @description changeMethod Function to switch to view of payment methods
   */
  changeMethod() {
    this.BNPL.emit();
  }

}
